import React from "react"

export const renderHTML = (rawHTML) => {
  if (!rawHTML) return null
  return React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } })
}
